import { recordEventCustomOnly } from 'utilities/uTagging';
import { formatText } from 'core/i18n';

const getCustomPasswordErrorsByFlags = ({ passAscDesc, passEquals, passBirthYear, passBirthDay }) => {
    const errors = [];
    if (passAscDesc)
        errors.push({ errorCategory: 'ascendant-password', errorDescription: formatText('field-passAscDesc') });
    if (passEquals) errors.push({ errorCategory: 'equal-password', errorDescription: formatText('field-passEquals') });
    if (passBirthYear || passBirthDay)
        errors.push({ errorCategory: 'hasBirthDay-password', errorDescription: formatText('field-passBirthYear') });

    return errors;
};

export const doTagPassword = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'accessKey',
        eventCategory: 'onboarding/step1/accessData',
        eventAction: 'clickTextBox',
        eventLabel: 'accessKeyTextBox',
    });
};
export const doTagObscurePassword = show => {
    const action = show ? 'show' : 'hide';
    recordEventCustomOnly({
        action,
        format: 'button',
        component: 'form',
        element: 'accessKey',
        eventCategory: 'onboarding/step4/accessKey',
        eventAction: 'clickButton',
        eventLabel: `${action}Button`,
    });
};
export const doTagModifyIdDocument = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'link',
        component: 'form',
        element: 'modifyIdDocument',
        eventCategory: 'onboarding/step4/accessKey',
        eventAction: 'clickLink',
        eventLabel: 'modifyIdDocument',
    });
};

export const doTagClickStartButton = () => {
    recordEventCustomOnly({
        action: 'start',
        format: 'button',
        component: 'form',
        element: 'start',
        eventCategory: 'onboarding/step4/accessKey',
        eventAction: 'clickButton',
        eventLabel: 'startButton',
    });
};

export const doTagIsValidAndGoNext = () => {
    recordEventCustomOnly({
        event_name: 'event_success',
        eventCategory: 'onboarding/step4/accessKey',
        eventAction: 'success',
        eventLabel: 'backend',
        action: 'success',
        format: 'steps',
        component: 'funnel',
        element: 'accessKey',
    });
};
export const doTagPasswordError = ({ errorCategory, errorDescription }) => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textBox',
        element: 'errorAccessKeyField',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
        component: 'form',
        eventCategory: 'onboarding/step4/accessKey',
        errorCategory,
        errorDescription,
    });
};
export const doTagPasswordErrors = ({ passAscDesc, passEquals, passBirthYear, passBirthDay }) => {
    getCustomPasswordErrorsByFlags({ passAscDesc, passEquals, passBirthYear, passBirthDay }).forEach(
        doTagPasswordError
    );
};
